
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from "@ngrx/store";
import { NzNotificationService } from 'ng-zorro-antd/notification';
import * as UserActions from "src/app/services/state/actions/user.action";
import { AppState } from "src/app/services/state/app.state";
import { environment } from 'src/environments/environment';
import { TenantMenuService } from "../pages/admin/services/tenant-menu.service";
import { PlatformLocation } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { StorageService } from "front-common-toolkits";
import { AuthenticationService } from "../services/utils/authentication.service";
@Injectable({
  providedIn: 'root'
})
export class RouterGuardGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService, private storageService: StorageService, private location: PlatformLocation, private menuService: TenantMenuService, private cookieService: CookieService, private notification: NzNotificationService, private store: Store<AppState>) { }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (environment.isAdmin) {
      return true
    } else {
      let subView=[
        {
          'mainUrl':'bpmnConfig',
          'subUrl':'bpmnDesign'
        },{
          'mainUrl':'reportConfig',
          'subUrl':'reportDesign'
        }
      ]
      var routeConfigPath = route.routeConfig.path;
      const config = subView.find(view => view.subUrl === route.routeConfig.path );
      if (config){
        routeConfigPath=config.mainUrl;
      }

      let result = false;
      
      let availableSubSystems = await this.menuService.getTenantMenus().toPromise();

      if (availableSubSystems) {
        availableSubSystems.forEach(subSys => {
          if (subSys.menuUrl?.includes(routeConfigPath)) {
            result = true;
          }
        })
      }
      // console.log('这是守卫的地址',route.routeConfig.path)
      if (!result) {
        console.log('router-guard.guard多调一次刷新请求')
        await this.authenticationService.refreshToken(true)
        let availableSubSystems = await this.menuService.getTenantMenus().toPromise();

        if (availableSubSystems) {
          availableSubSystems.forEach(subSys => {
            if (subSys.menuUrl?.includes(routeConfigPath)) {
              result = true;
            }
          })
        }
        if (!result) {
          this.notification.warning('获取不到用户菜单,请重新登录！', '');
          //当前路径不属于系统配置的路径 跳转登录 
          // bug 修复 【PC端 - 角色权限】用户在新tab页面直接访问智能排产url，在用户没有该页面权限前提下，请求时页面一片空白，提示”没有权限“，建议提示过后跳转到登录页面，不要停留在空白页面上
          // let len = this.location['location'].hash.split('/').length - 1
          // let name = this.location['location'].hash.split('/')[len]
          //路由方式不同 可能导致上面方式失效，改用下面方式
          if (!(route['children'] && route['children'].length > 0)) {
            let name = route.routeConfig.path
            let login = true
            let allPath = [...availableSubSystems, { menuUrl: '/help' }]
            if (allPath) {
              allPath.forEach(subSys => {
                if (subSys.menuUrl?.includes(name)) {
                  login = false
                }
              })
            }

            if (login) {
              console.log('router-guard.guard.ts  方法canActivate 301', this.cookieService.get('token'))
              this.store.dispatch(new UserActions.RemoveUser())
              this.cookieService.delete('token');
              this.cookieService.delete('refreshToken');
              this.cookieService.delete('tenantLoginResult'); //20211224 baij  退出登录后会回到选择企业页面，应该是回到登录首页
              sessionStorage.removeItem('halo-menu')    //20220211  b

              this.router.navigate(['/login']);
            }
          }

          // }

        }
      }


      //修复帮助中心所有用户有权限进入
      return result
    }


  }

}
